import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import ScrollAnimation from "./ScrollAnimation";
import Header from "./components/Header";
import Footer from "./components/Footer";

// HOME PAGE SECTIONS
import Hero from "./components/Hero";
import About from "./components/About";
import HowItWorks from "./components/HowItWorks";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import CTA from "./components/CTA";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import CookieConsent from "./components/CookieConsent";
// FULL PAGES
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";
import Shipping from "./pages/Shipping";
import Payment from "./pages/Payment";
import Compliance from "./pages/Compliance";
import DomesticShipping from "./pages/DomesticShipping";
import InternationalShipping from "./pages/InternationalShipping";
import EcommerceFulfillment from "./pages/EcommerceFulfillment";
import Warehousing from "./pages/Warehousing";
import CustomsClearance from "./pages/CustomsClearance";
import BulkFreight from "./pages/BulkFreight";
import Partners from "./components/Partners";
import FAQ from "./components/FAQ";
import OrderTrackingPage from "./pages/OrderTrackingPage";

export default function App() {
  return (
    <Router>
     <ScrollToTop />
      <Header />
      <ScrollAnimation>
        <Routes>

          {/* ⭐ HOME PAGE */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <About />
                <HowItWorks />
                <Services />
                <WhyChooseUs />
                <Partners />
                <CTA />
                <Reviews />
                <FAQ />
                <Contact />
              </>
            }
          />

          {/* ⭐ OTHER PAGES */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/shipping-policy" element={<Shipping />} />
          <Route path="/payment-policy" element={<Payment />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/services/domestic" element={<DomesticShipping />} />
          <Route path="/services/international" element={<InternationalShipping />} />
          <Route path="/services/e-commercefulfillment" element={<EcommerceFulfillment />} />
          <Route path="/services/warehousing" element={<Warehousing />} />
          <Route path="/services/customs-clearance" element={<CustomsClearance />} />
          <Route path="/services/bulk-freight" element={<BulkFreight />} />
          <Route path="/track" element={<OrderTrackingPage />} />
        </Routes>
      </ScrollAnimation>
      <Footer />
      <CookieConsent />
    </Router>
  );
}
